<template>
    <div class="d-flex navtop-container" :class="{ 'nav-top-container-mobile': !this.$vuetify.display.mdAndUp }">

        <div class="hidden-sm-and-down" style="width:300px"></div>


        <div class="navigation d-flex mt-1"
            :class="{ 'navigation-mobile flex-column align-center justify-space-evenly py-12': !this.$vuetify.display.mdAndUp }"
            :style="{ fontSize: this.$vuetify.display.mdAndUp ? '1.2rem' : '1.6rem' }">
            <router-link to="/schedule" class="d-flex w-100 justify-center align-start" @click="this.mobileMenuClose()">
                <p class="">schedule</p>
            </router-link>
            <router-link to="/program" class="d-flex w-100 justify-center" @click="this.mobileMenuClose()">
                <p style="transform:rotate(-6.3deg)"><i>program</i></p>
            </router-link>

            <router-link to="/about" class=" d-flex flex-column w-100 justify-center align-center my-n12"
                @click="this.mobileMenuClose()">
                <img class="" :src="require('@/assets/about_web.png')" :width="mobile ? 130 : 105"
                    style="transform:translateY(8px);" />
            </router-link>

            <!-- <router-link to="/works" class="d-flex w-100 justify-center" @click="this.mobileMenuClose()"
                :style="{ 'letter-spacing': mobile ? '-1px' : '-1px' }">
                <p><i>works</i></p>
            </router-link> -->

            <router-link to="/" class="d-flex w-100 justify-center align-center" @click="this.mobileMenuClose()"
                style="text-decoration: none;">
                <img width="25" height="25" :src="require('@/assets/radioicon.png')" />
            </router-link>
        </div>


    </div>
</template>
  
<script>


export default {

    inject: ['eventBus', 'mobile'],
    components: {
    },
    methods: {
        mobileMenuClose() {
            this.eventBus.emit('close-mobile-menu', true)
        },
    },

}
</script>
  

<style scoped>

.navtop-container {
    height: 30px;
}

.navtop-container-mobile {
    width: 100%;
}

a {
    text-decoration: none;
    color: black;
}

a:hover,
a:active,
a.router-link-active {
    text-decoration: line-through;

}

.navigation {
    width: calc(100dvw - 300px);
    font-size: 20px;
}

.navigation-mobile {
    width: 100%;
    height: calc(100dvh - 70px);
    font-size: 30px;
}

.blue-border {
    border: 2px solid blue;
}
</style>
  